import { render, staticRenderFns } from "./shareholderInformation.vue?vue&type=template&id=2d4a0057&scoped=true"
import script from "./shareholderInformation.vue?vue&type=script&lang=js"
export * from "./shareholderInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a0057",
  null
  
)

export default component.exports